import { isMac } from './platform';
import { type ShortcutDefinition, SHORTCUTS, type ShortcutId } from './registry';

const MODIFIERS_MAC: Record<string, string> = {
    mod: '⌘',
    ctrl: '⌃',
    alt: '⌥',
    shift: '⇧',
};

const MODIFIERS_OTHER: Record<string, string> = {
    mod: 'Ctrl',
    ctrl: 'Ctrl',
    alt: 'Alt',
    shift: 'Shift',
};

const SPECIAL_KEYS: Record<string, string> = {
    up: '↑',
    down: '↓',
    arrows: '←/→',
    click: 'Click',
};

const formatToken = (token: string, mac: boolean): string => {
    const modifiers = mac ? MODIFIERS_MAC : MODIFIERS_OTHER;

    if (modifiers[token]) {
        return modifiers[token];
    }

    if (SPECIAL_KEYS[token]) {
        return SPECIAL_KEYS[token];
    }

    if (token.length === 1) {
        return token.toUpperCase();
    }

    return token.charAt(0).toUpperCase() + token.slice(1);
};

export const formatShortcutSegments = (id: ShortcutId, mac: boolean = isMac()): string[] => {
    const { display, keys }: ShortcutDefinition = SHORTCUTS[id];

    if (display) {
        return [display];
    }

    return keys.split('+').map((token) => formatToken(token.trim().toLowerCase(), mac));
};

export const withShortcutHint = (label: string, id: ShortcutId): string => {
    const mac = isMac();

    return `${label} (${formatShortcutSegments(id, mac).join(mac ? '' : '+')})`;
};
